import script from "./EmbarquesProdutosSmartMode.vue?vue&type=script&setup=true&lang=js"
export * from "./EmbarquesProdutosSmartMode.vue?vue&type=script&setup=true&lang=js"

import "./EmbarquesProdutosSmartMode.vue?vue&type=style&index=0&id=0318f58a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0318f58a"]])

export default __exports__